import { styled } from "@mui/material";

export const TextSkeletonWrapper = styled("div")(({ theme }) => ({
  height: 12,

  [theme.breakpoints.up("md")]: {
    height: 14,
  },
}));
